// Module
var code = `<div class="sub-header" ng-class="{'sub-header--small': \$ctrl.tab == true}">
  <div class="sub-header__column-left">
    <h1 class="sub-header__title">{{\$ctrl.header}}</h1>
  </div>
  <div class="sub-header__column-right" ng-transclude></div>
  <div class="clearfix"></div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/sub-header/sub-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;